import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type RemovePortfolioResponseType = ResponseType<null>;

function useRemovePortfolioMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<RemovePortfolioResponseType>["response"],
    AxiosResponseAndError<RemovePortfolioResponseType>["error"],
    string
  >({
    mutationFn: (data) =>
      ApiRequest.delete<RemovePortfolioResponseType>(
        `${requestURLs.project}/protfolio/${data}`
      ),
  });

  return mutation;
}

export default useRemovePortfolioMutation;
